/**
 * @desc 获取国家列表
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<Array<defs.tms.CountryResponseDto>>;
export function request(
  params: API.tms.basicData.getCountry.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/tms/basicData/getCountryList`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
